import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Card, Grid } from 'semantic-ui-react';
import { UniversalLink, Pagination, PreviewImage } from '@plone/volto/components';
import { BodyClass, flattenToAppURL } from '@plone/volto/helpers';
import { searchContent } from '@plone/volto/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';


const BlogView = ({ content }) => {

  const getViewURL = function (item) {
    let URL = flattenToAppURL(item['@id']);
    if (item['@type'] === 'File') {
      URL += '/@@display-file/file';
    }
    if (item['@type'] === 'Image') {
      URL += '/@@display-file/image';
    }
    if (item?.getRemoteUrl) {
      URL = item?.getRemoteUrl;
    }
    return URL;
  };

  const dispatch = useDispatch();
  const items = useSelector((state) => state.search.subrequests.items?.items);
  const total = useSelector((state) => state.search.subrequests.items?.total);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(30);

  useEffect(() => {
    let contentFilter = {
      exclude_from_nav: 'false',
      b_size: pageSize,
      b_start: currentPage * pageSize,
      sort_on: 'getObjPositionInParent',
      metadata_fields: ['content_icon', 'getRemoteUrl'],
    };
    contentFilter['path.depth'] = 1
    dispatch(searchContent(flattenToAppURL(content['@id']), contentFilter, 'items'));
  }, [dispatch, currentPage, pageSize]);

  const onChangePage = (event, activePage) => {
    event.preventDefault();
    setCurrentPage(activePage.value);
  };

  const onChangePageSize = (event) => {
    event.preventDefault();
    setPageSize(parseInt(event.target.text));
    setCurrentPage(0);
  };


  return (
    <>
      <BodyClass className="blogView" />

      <Container id="content-core" className="blogView__page">
        
        <Grid columns={12} as="ul" className='blogView__list list-unstyled pt-0'>

          {items &&
            items.map((item, index) => (
              <Grid.Column key={item['@id']} mobile={12} tablet={6} computer={4} as="li" className='position-relative'>
                <Card
                  as="article"
                  fluid
                  className={
                    'position-relative blogItem ' +
                    (item.image_field ? 'blogItem--hasImage' : 'blogItem--noImage')
                  }
                >
                  {item.image_field && (
                    <div className='m-0 blogItem__imgWrapper'>
                      <PreviewImage
                        item={item}
                        alt={item.image_caption ? item.image_caption : ''}
                        className="blogItem__img"
                        responsive={true}
                        sizes="(min-width: 1600px) 500px, (min-width: 1280px) 400px, (min-width: 600px) 200px, 50vw"
                        loading="lazy"
                      />
                    </div>
                  )}                  
                  <Card.Content className="blogItem__text ">
                    <Card.Header as="h2" className="blogItem__title">
                      <UniversalLink
                        href={getViewURL(item)}
                        className="blogItem__link stretched-link"
                      >{item.title}
                      </UniversalLink>
                    </Card.Header>
                    {item.description && (
                      <Card.Description as="p" className="blogItem__desc">
                        {item.description}
                      </Card.Description>
                    )}
                    <div className="text-end mt-auto w-100">
                      <span className="item__readMore">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </div>
                  </Card.Content>
                </Card>
              </Grid.Column>
            ))}

        </Grid>

        {total > pageSize && (
          <nav className="pagination">
            <Pagination
              current={currentPage}
              total={Math.ceil(total / pageSize)}
              onChangePage={onChangePage}
              onChangePageSize={onChangePageSize}
            />
          </nav>
        )}

      </Container>
    </>
  );
};

export default BlogView;